import { useContext, useEffect } from "react";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { ContainerPuntoControl } from "./localStyle";
import { wsPostTrazaPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import puntoControlImage from "_+_Portal/assets/images/generico/puntoControl.png";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { PortalContext } from "_+_Portal/context/Provider";
import { GlobalContext } from "global/context/Provider";

const PuntoControl = ({ turnoActual }) => {
  //#region --------- context ---------------
  const { puntoControlState, turnosSeleccionadosState, pasoDispatch } =
    useContext(AutocheckContext);
  const { selectDropDownState } = useContext(PortalContext);
  const { authState } = useContext(GlobalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const dataView = {
    nombre: "No podés continuar la recepción por este medio",
    descripcion:
      "Por favor realizá la fila para ser atendido por un colaborador",
    verLogo: true,
  };
  const listTurnosSeleccionado =
    turnosSeleccionadosState?.turnosSeleccionados?.data ?? [];
  const pacienteElegido =
    selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido
      ?.paciente;

  const pacienteCodigo = pacienteElegido
    ? pacienteElegido.codigo
    : authState?.auth?.data?.paciente?.codigo;

  let parsedConfig = {};
  try {
    parsedConfig = JSON.parse(localStorage.getItem("config")) || {};
  } catch (e) {
    parsedConfig = {};
  }
  let sectorTurno = parsedConfig.sectorTurno;
  const turno = listTurnosSeleccionado?.[turnoActual];
  const idTipo = puntoControlState.puntoControl.idTipo;
  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const handleVolver = () => {
    setPaso("Home")(pasoDispatch);
  };
  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  useEffect(() => {
    const fecha = new Date().toISOString();
    const dto = {
      idtipo: idTipo,
      fechaalta: fecha,
      idpaciente: Number(pacienteCodigo),
      idsectoralta: Number(sectorTurno),
      idterminal: -1,
      idturno: turno?.idturno ? turno.idturno : -1,
      idprotocolo: turno?.idProtocolo ? turno.idProtocolo : -1,
    };
    wsPostTrazaPuntoControl(dto)(() => {});
  }, []);
  //#endregion  -------- useEffect ---------------

  return (
    <LayoutPasos
      volverTo={"/autocheckin/resumen"}
      handleClick={handleVolver}
      type={"no-circle"}
      title={"ATENCIÓN"}
    >
      <ContainerPuntoControl
        initial={{ opacity: 0, y: +100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <h1>{dataView.nombre}</h1>
        <span>{dataView.descripcion}</span>
        {dataView.verLogo ? (
          <img src={puntoControlImage} alt="Icono ilustrativo" />
        ) : (
          ""
        )}
        <button onClick={handleVolver} className="danger">
          Salir
        </button>
      </ContainerPuntoControl>
    </LayoutPasos>
  );
};

export default PuntoControl;
